<template lang="pug">
  el-tag.course-tag(closable effect="dark" :style="{opacity: course.isPreview ? 0.4: 1.0}" :type="backgroundColor(course)" :color="usingColor(course)" :size="courseSize" :disable-transitions="true" @close="updateCourse(course)")
    el-icon.el-icon-info(@click.native="showCourseDetail(course)")
    span.hidden-lg-and-down {{ coursePreventOverflow(15) }}
    span.hidden-md-and-down.hidden-xl-only {{ coursePreventOverflow(12) }}
    span.hidden-sm-and-down.hidden-lg-and-up {{ coursePreventOverflow(6) }}
    span.hidden-xs-only.hidden-md-and-up {{ coursePreventOverflow(8) }}
    span.hidden-sm-and-up {{ coursePreventOverflow(4) }}

</template>
<script>
import 'element-ui/lib/theme-chalk/display.css';
export default {
  name: 'course-tag',
  props: [
    'course',
    'courseSize',
    'coursesInGrid',
    'backgroundColor'
  ],
  methods: {
    coursePreventOverflow(length){
      const l = parseInt(length)
      var display = this.course.cname.substr(0,l)
      if(this.course.cname.length > l){
        display += '.'
      }
      return display
    },
    usingColor(){
      return ''
      // if (!course) return '';
      // return {
      //   '必修': 'orange',
      //   '選修': 'green',
      //   '通識': 'purple',
      // }[course.type]
    }
  }
}
</script>
<style>

.course-tag {
  margin-left: 0px;
  margin-right: 0px;
}

.course-tag {
}
</style>
